import React from 'react';

import {
  Drawer,
  ErrorHandler,
  LoadingState,
  StandardNoAccessErrorMessage,
} from '@common/components';
import { HourBlockForm } from '@timekeeping/components';
import { useQuery } from '@common/hooks';
import { ManagerWorkerTimesheet } from '@timekeeping/graphql';

export const AddHourBlockDrawer = ({
  open,
  onClose,
  timecardId = '',
}: {
  open: boolean;
  onClose: () => void;
  timecardId?: string;
}) => {
  const { data, loading, error } = useQuery(ManagerWorkerTimesheet, {
    skip: !timecardId,
    variables: { id: timecardId },
  });

  if (error) {
    return (
      <ErrorHandler
        error={error}
        messageType="contextual"
        log="AddHourBlockDrawer"
      />
    );
  }

  const workerTimesheet = data?.timesheet;

  const renderDrawerBody = () => {
    if (!timecardId) {
      return null;
    }

    if (loading) {
      return <LoadingState />;
    }

    if (!workerTimesheet?.canManagerUpsertHours.value) {
      return <StandardNoAccessErrorMessage />;
    }

    return (
      <HourBlockForm
        action="add"
        onSuccess={onClose}
        workerTimesheet={workerTimesheet}
      />
    );
  };

  return (
    <Drawer
      open={open}
      onClose={onClose}
      className="HourBlockDrawer"
      title="Add Hours"
    >
      {renderDrawerBody()}
    </Drawer>
  );
};
